import ApiCalls from "../util/ApiCalls";

class JourneyGoalService {
    async getAll() {
      return ApiCalls.defaultGet("/journey/goals", {});
    }
}
  
export default new JourneyGoalService();